import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import {checkDate, edit, editOld, getAllByGroupIdAndLessonNumber} from "../../http/StudentLessonApi";
import {
    Alert,
    Button,
    Card,
    ConfigProvider,
    DatePicker,
    Divider,
    Form,
    Input,
    Spin,
    Table
} from "antd";
import {LeftOutlined} from "@ant-design/icons";
import locale from "antd/es/locale/ru_RU";

export default function EditOldLesson() {

    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    const [lessonNumber, setLessonNumber] = useState('');
    const [oldDate, setOldDate] = useState(dayjs());
    const [date, setDate] = useState(dayjs());
    const [homework, setHomework] = useState("");
    const [lessonTheme, setLessonTheme] = useState("");
    const [lessonCost, setLessonCost] = useState(500);
    const [costVideo, setCostVideo] = useState(300);
    const [costOwn, setCostOwn] = useState(0);
    const [costOwn2, setCostOwn2] = useState(0);
    const [costOwn3, setCostOwn3] = useState(0);
    const [costOwn4, setCostOwn4] = useState(0);
    const [students, setStudents] = useState([]);

    const [selectedStatuses, setSelectedStatuses] = useState({});

    const [options] = useState([
        {
            label: 'Посещал занятие',
            value: 'ATTEND_LESSON',
        },
        {
            label: 'Смотрел видео',
            value: 'WATCH_VIDEO',
        },
        {
            label: 'Cвоя цена',
            value: 'OWN_PRICE',
        },
        {
            label: 'Cвоя цена 2',
            value: 'OWN_PRICE2',
        },
        {
            label: 'Cвоя цена 3',
            value: 'OWN_PRICE3',
        },
        {
            label: 'Cвоя цена 4',
            value: 'OWN_PRICE4',
        },
    ])

    const columns = [
        {
            title: 'Имя ученика',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Присутствие на занятии',
            dataIndex: 'status',
            key: 'status',
        },
    ];

    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);
    const [alertErrorVisible, setAlertErrorVisible] = useState(false);
    const dateFormat = 'DD.MM.YYYY';

    dayjs.extend(updateLocale);
    dayjs.updateLocale("ru", {
        weekStart: 1
    });


    const [alertVisible, setAlertVisible] = useState(false);

    const handleClose = () => {
        setAlertVisible(false);
    };

    const handleErrorClose = () => {
        setAlertErrorVisible(false);
    };

    const handleStatusChange = (studentId, status) => {
        setSelectedStatuses(selectedStatuses => ({
            ...selectedStatuses,
            [studentId]: status,
        }));
    };

    const checkDateAvailability = async (rule, value) => {
        console.log(oldDate.format(dateFormat) + " - " + date.format(dateFormat))
        if (+oldDate !== +date) {
            console.log("!=")
            try {
                const response = await checkDate(localStorage.getItem('token'), params.id, value);
                if (response.data) {
                    return Promise.resolve();
                } else {
                    return Promise.reject('Выбранная дата уже занята');
                }
            } catch (error) {
                console.error(error);
                return Promise.reject('Произошла ошибка при проверке уникальности');
            }
        }
    };

    function getStatusText(status) {
        switch (status) {
            case 'ATTEND_LESSON':
                return 'Посещал занятие';
            case 'WATCH_VIDEO':
                return 'Смотрел видео';
            case 'OWN_PRICE':
                return 'Занимался по особой цене';
            case 'OWN_PRICE2':
                return 'Занимался по особой цене 2';
            case 'OWN_PRICE3':
                return 'Занимался по особой цене 3';
            case 'OWN_PRICE4':
                return 'Занимался по особой цене 4';
            default:
                return 'Неизвестный статус';
        }
    }

    const getLesson = async () => {
        await getAllByGroupIdAndLessonNumber(localStorage.getItem('token'), params.id, params.number).then(
            response => {
                setStudents(
                    response.data.map(row => ({
                        key: row.student.id,
                        name: `${row.student.name} (${row.balanceLesson}₽ + ${row.bonusBalanceLesson}₽ бонусов)`,
                        status: getStatusText(row.paymentStatus)
                    }))
                );
                response.data.forEach(row => {
                    handleStatusChange(row.student.id, row.paymentStatus)
                });
                setLessonNumber(response.data[0].lessonNumber);
                setDate(dayjs(response.data[0].date).endOf('day'));
                setOldDate(dayjs(response.data[0].date).endOf('day'));
                setHomework(response.data[0].homework);
                setLessonTheme(response.data[0].lessonTheme);
                setLessonCost(response.data[0].lessonCost);
                setCostVideo(response.data[0].costVideo);
                setCostOwn(response.data[0].costOwn);
                setCostOwn2(response.data[0].costOwn2);
                setCostOwn3(response.data[0].costOwn3);
                setCostOwn4(response.data[0].costOwn4);
                setLoading(false);
            }).catch(
            error => {
                console.log(error)
            }
        );
    };

    useEffect(() => {
        getLesson();
    }, []);

    const onFinish = async (values) => {
        setAdding(true);
        console.log(selectedStatuses)
        console.log(params.id + " - "  + date.endOf('day') + " - "  + lessonNumber + " - "  + homework + " - "  + lessonTheme + " - "  + lessonCost + " - "  + costVideo + " - "  + costOwn + " - "  + costOwn2 + " - "  + costOwn3 + " - "  + costOwn4 + " - "  + selectedStatuses)
        await edit(localStorage.getItem('token'), params.id, date.endOf('day'), lessonNumber, homework, lessonTheme, lessonCost, costVideo, costOwn, costOwn2, costOwn3, costOwn4, selectedStatuses).then(
            response => {
                setAlertVisible(true);
                goBack()
            }).catch(
            error => {
                setAlertErrorVisible(true);
                setAdding(false);
                console.log(error)
            }
        );
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed', errorInfo);
    }

    return (
        <div
            style={{
                minHeight: '100vh',
            }}
        >
            <Button onClick={goBack} style={{
                margin: '1vw',
            }}><LeftOutlined/> Назад</Button>
            <div
                style={{
                    minHeight: '100vh',
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <div>
                    <Divider>Редактирование занятия № {lessonNumber}</Divider>
                    {loading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <Spin/>
                        </div>
                    ) : (
                        <Card
                            style={{display: "inline-block",}}
                        >
                            <Form
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                labelCol={{span: 6}}
                                wrapperCol={{span: 18}}
                                layout="horizontal"
                                style={{
                                    marginBottom: '1vw',
                                }}
                            >
                                <ConfigProvider locale={locale}>
                                    <Form.Item
                                        label="Дата"
                                        name="date"
                                        initialValue={date}
                                        rules={[
                                            {
                                                validator: checkDateAvailability,
                                            },
                                        ]}
                                    >
                                        <DatePicker
                                            name="date"
                                            format={dateFormat}
                                            onChange={event => {
                                                setDate(event.endOf('day'))
                                            }}
                                            allowClear={false}
                                            style={{
                                                width: '100%',
                                            }}
                                        />
                                    </Form.Item>
                                </ConfigProvider>
                                <Form.Item
                                    name="lessonTheme"
                                    label="Тема занятия"
                                    initialValue={lessonTheme}
                                >
                                    <Input.TextArea
                                        onChange={event => {
                                            setLessonTheme(event.target.value)
                                        }}
                                        type="text"
                                        maxLength={255}
                                        placeholder="Тема занятия"
                                        style={{
                                            width: '100%',
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="homework"
                                    label="Домашнее задание"
                                    initialValue={homework}
                                >
                                    <Input.TextArea
                                        onChange={event => {
                                            setHomework(event.target.value)
                                        }}
                                        type="text"
                                        placeholder="Домашнее задание"
                                        style={{
                                            width: '100%',
                                        }}
                                    />
                                </Form.Item>
                                {adding ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <Spin/>
                                    </div>
                                ) : (
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{
                                            width: '100%',
                                        }}>
                                        Сохранить
                                    </Button>
                                )}
                            </Form>
                            <Card
                                style={{display: "inline-block",}}
                            >
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Стоимость занятия"
                                >
                                    {lessonCost}₽
                                </Card>
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Стоимость видео"
                                >
                                    {costVideo}₽
                                </Card>
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Особая cтоимость"
                                >
                                    {costOwn}₽
                                </Card>
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Особая cтоимость 2"
                                >
                                    {costOwn2}₽
                                </Card>
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Особая cтоимость 3"
                                >
                                    {costOwn3}₽
                                </Card>
                                <Card
                                    style={{
                                        marginBottom: '1vw',
                                    }}
                                    type="inner"
                                    title="Особая cтоимость 4"
                                >
                                    {costOwn4}₽
                                </Card>
                                <Table
                                    columns={columns}
                                    dataSource={students}
                                    pagination={false}
                                    bordered
                                    style={{
                                        width: '100%',
                                    }}
                                />
                            </Card>
                            {alertVisible && (
                                <Alert message="Успешно сохранено" type="success" closable
                                       afterClose={handleClose}
                                       style={{marginTop: '1vw',}}/>
                            )}
                            {alertErrorVisible && (
                                <Alert message="Ошибка сохранения" type="error" closable
                                       afterClose={handleErrorClose}
                                       style={{marginTop: '1vw',}}/>
                            )}
                        </Card>
                    )}
                </div>
            </div>
        </div>
    )
}